import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface ReauthBannerProps {
  onReconnect: () => void;
  isLoading: boolean;
}

export function ReauthBanner({ onReconnect, isLoading }: ReauthBannerProps) {
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Reconnection required</AlertTitle>
      <AlertDescription className="space-y-2">
        <p>
          Google has invalidated your access. Reviews will not sync until you reconnect your Google
          Business Profile.
        </p>
        <Button size="sm" variant="outline" onClick={onReconnect} disabled={isLoading}>
          {isLoading ? "Starting..." : "Reconnect Google Business"}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
